import { render, staticRenderFns } from "./PlusIconButton.vue?vue&type=template&id=3eb860b1&scoped=true"
import script from "./PlusIconButton.vue?vue&type=script&lang=js"
export * from "./PlusIconButton.vue?vue&type=script&lang=js"
import style0 from "./PlusIconButton.vue?vue&type=style&index=0&id=3eb860b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb860b1",
  null
  
)

export default component.exports